import { RootState } from 'store';

export const selectQuickMenuNarrow = ({ main }: RootState) => main.app.quickMenuNarrow;
export const selectViewType = ({ main }: RootState) => main.app.viewType;
export const selectIsDesktopView = ({ main }: RootState) => main.app.isDesktopView;
export const selectHasParent = ({ main }: RootState) => main.app.hasParent;
export const selectAnnouncementConfig = ({ main }: RootState) => main.app.announcementConfig;
export const selectOverdueInvoiceAnnouncement = ({ main }: RootState) => main.app.overdueInvoiceAnnouncement;
